import { playDigitalClientV1 } from "../../play-digital-client-v1";
import {
    PlayerDetailModel,
    PersonalInfoModel,
    UpdatePersonalContactRequest,
    NewPasswordRequest,
    ChangePasswordRequest,
} from "../../models/account-models";
import { ConsentDetailModel, ConsentDetailUpdate } from "../../models/consent-models";
import { AxiosResponse } from "axios";
import { CardModel } from "../../models/shared-models";

export async function fetchPlayerDetail(): Promise<PlayerDetailModel> {
    const response = await playDigitalClientV1.get<PlayerDetailModel>("/players/self/profile-details");
    return response.data;
}

export async function callLockCard(): Promise<void> {
    await playDigitalClientV1.post("/players/self/card/request-lock");
}

export async function callUnlockCard(): Promise<void> {
    await playDigitalClientV1.post("/players/self/card/request-unlock");
}
export async function callNewCard(): Promise<CardModel> {
    const response = await playDigitalClientV1.post<CardModel>("/players/self/card/request-new");
    return response.data;
}

export async function callUpdatePersonalInfo(data: PersonalInfoModel): Promise<void> {
    await playDigitalClientV1.put<void, AxiosResponse<void>, PersonalInfoModel>(
        "/players/self/profile-details/personal-info",
        data
    );
}

export async function callUpdatePhone(newPhone: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, UpdatePersonalContactRequest>(
        "/players/self/profile-details/request-contact-update",
        {
            contactType: "PHONE",
            newValue: newPhone,
        }
    );
}

export async function callUpdateEmail(newEmail: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, UpdatePersonalContactRequest>(
        "/players/self/profile-details/request-contact-update",
        {
            contactType: "EMAIL",
            newValue: newEmail,
        }
    );
}

export async function callChangePassword(oldPassword: string, newPassword: string) {
    await playDigitalClientV1.put<void, AxiosResponse<void>, ChangePasswordRequest>("/players/self/password", {
        oldPassword: oldPassword,
        newPassword: newPassword,
    });
}

export async function requestPasswordReset(cardId: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, NewPasswordRequest>("/players/request-password-reset", {
        type: "CARD_ID",
        value: cardId,
    });
}

export async function getConsentDetail(id: string): Promise<ConsentDetailModel> {
    const response = await playDigitalClientV1.get<ConsentDetailModel>("/players/self/consents/" + id);
    return response.data;
}

export async function updateConsentDetail(
    id: string,
    enabled: boolean,
    version: string,
    language: string
): Promise<ConsentDetailUpdate> {
    const response = await playDigitalClientV1.put<ConsentDetailUpdate>("/players/self/consents/" + id, {
        id: id,
        version: version,
        enabled: enabled,
        language: language,
    });
    return response.data;
}
